<template lang="pug">
  v-col
    header
      ul
        li(
          v-for="(passo, passoIndex) in passos"
          :key="passo"
          :active="isActive(passo)"
          :done="isDone(passo)"
        )
          number-circle(
            :done="isDone(passo)"
            :active="isActive(passo)"
            :number="passoIndex + 1"
          )
          h2(
            v-if="$vuetify.breakpoint.mdAndUp"
            :style="{ color: isDone(passo) ? 'green' : '#111d' }"
          ) {{ passo }}
          v-icon(
            size="40"
            :color="isDone(passo) ? 'green' : '#0006'"
          ) {{ icon }}
</template>
<script>
  import NumberCircle from './NumberCircle'
  export default {
    name: 'StepHeader',
    components: { NumberCircle },
    props: {
      etapa: {
        type: [String],
        default: 'create',
      },
    },
    data () {
      return {
        icon: 'mdi-chevron-right',
        passos: [
          'Criar Grupo',
          'Convidar Equipe',
        ],
      }
    },
    methods: {
      isDone (passo) {
        const { etapa } = this
        return (passo === 'Criar Grupo' && etapa !== 'create')
      },
      isActive (passo) {
        const { etapa } = this
        return (passo === 'Criar Grupo' && etapa === 'create') || (passo === 'Convidar Equipe' && (etapa === 'options' || etapa === 'invitebyemail' || etapa === 'invitebylink'))
      },
    },
  }
</script>
<style lang="scss" scoped>
ul {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    transition: ease-out 0.2s;
    &[active],
    &[done] {
      opacity: 1;
    }
    h2 {
      margin-left: 5px;
    }
  }
}
</style>
